import { useEffect } from 'react';
import { replaceTabParams } from '../utils/projectTabUrl';

/**
 * Keeps a tab's selected element in the URL (utils/projectTabUrl TAB_PARAMS): `values` (`{ [param]: value | null }`)
 * written with replace whenever they change, so Back, a reload or a copied link return to it; null drops a param (a
 * default, or something that is gone). Only while the URL is on `tab`, and only once `ready` (the panel has read what it
 * shows): before that the params a link brought are left as they are.
 */
export default function useTabSelectionUrl(tab, values, { ready = true } = {}) {
  const key = JSON.stringify(values || {});
  useEffect(() => {
    if (ready) { replaceTabParams(tab, values || {}); }
  }, [tab, key, ready]); // eslint-disable-line react-hooks/exhaustive-deps
}
